export default {
  locale: "ja",
  language: {
    name: "日本語",
  },
  navbar: {},
  summary: {
    tonext: "次のサイクルには",
    blocks: "ブロックもあります。",
    totaltext1: "ノード",
    totaltext2: "の総数",
    consensustext1: "コンセンサス",
    consensustext2: "ノード",
    candidatetext1: "候補",
    candidatetext2: "ノード",
    synchronoustext1: "同期",
    synchronoustext2: "ノード",
    totalstake: "総質入れ額",
    oftotal: "ONT総循環の割合",
    increse: "順位の改善",
    increseexplain: "（前のサイクル以降）",
    applynow:
      "北斗ノードアプリケーションが開きました！適用するにはここをクリックしてください。",
    calculator: "ノードと誓約収入計算機",
    launchapp: "アプリを起動",
  },
  nodelist: {
    cnode: "コンセンサスノード",
    nnode: "候補ノード",
    checkmark: "Checkmark",
    long: "Long term",
    verified: "Verified contact information",
    stable: "Stable fee sharing ratio",
    harbinger: "Ontology Harbinger",
    checkdesc: "View details of node checkmark:",

    rank: "#",
    rankDesc: "前のサイクル以降",
    verification: "検証済みノード",
    name: "名前",
    top49: "状態",
    top49Desc:
      "サイクルの終わりまでに、上位49ノードが財団から報酬を受け取ります。",
    location: "地域",
    lastblocks: "最新区块",
    blockproduced: "生成区块",
    income: "上一周期手续费收益（ONG）",
    fee: "料金配分の割合",
    progress: "質入れの進捗",
    stake: "",
    stakeurl: "https://mp.weixin.qq.com/s/LqmfcDEZTQGEaQAOrjNQyg",
    initpos: "初期質入れ額",
    totalstake: "総質入れ額",
    reward1:
      "次のコンセンサス期間に質入れユーザーに割り当てられる料金の割合は、ノード自体によって設定されます。",
    annual: "年間収益率",
    annual1:
      "この推定データは、リアルタイムのネットワーク運用状況とONT/ONG価格から算出されています。",
    notopen: "非公開",
    gccurl:
      "https://medium.com/@theontologyteam/%E3%82%AA%E3%83%B3%E3%83%88%E3%83%AD%E3%82%B8%E3%83%BCgcc-%E3%82%B0%E3%83%AD%E3%83%BC%E3%83%90%E3%83%AB%E3%82%B3%E3%83%9F%E3%83%A5%E3%83%8B%E3%83%86%E3%82%A3%E8%B2%A2%E7%8C%AE%E8%80%85-%E3%83%97%E3%83%AD%E3%82%B0%E3%83%A9%E3%83%A0%E3%81%8C%E9%96%8B%E5%A7%8B%E3%81%95%E3%82%8C%E3%81%BE%E3%81%99-4fff6d49b089",
  },
  cobuild: {
    title: "共同構築ノード",
  },
  detail: {
    title: "节点信息",
    name: "名前",
    position: "地域",
    address: "財布アドレス",
    website: "网站",
    social: "社交平台",
    pk: "公開鍵",
    ontid: "ONT ID",
    transactions: "交易数",
    transfers: "转账数",
    stakeamount: "ノード質入れ額",
    userstake: "ユーザー質入れ",
    description: "紹介",
    rank: "順位",
    stakeNow: "質入れする",
  },
  tab: {
    balance: "残高",
    transactions: "取引",
    voter: "选民",
    transfer: "振替",
    balanceValue: "balance",
    transactionsValue: "transactions",
    voterValue: "voter",
    transferValue: "transfer",
  },
  back: {
    back: "返回",
  },
  balance: {
    name: "TOKEN",
    type: "タイプ",
    balance: "残高",
  },
  voter: {
    address: "財布アドレス",
    vote: "质押量",
    percent: "总百分比",
  },
  tx: {
    hash: "HASH",
    status: "状態",
    block: "ブロック",
    time: "時間",
    fee: "料金",
    result: "結果",
    height: "",
    from: "送信元",
    to: "送信先",
    amount: "金額",
    token: "TOKEN",
    way: "",
  },
  stake: {
    progress: "ステーキングの進行状況",
    round1: "（ラウンド",
    round2: "）",
    days: "日",
    hours: "時間",
    left: "残り",
    currnetround1: "現在のラウンドで（推定）",
    currnetround: "現在のラウンドで",
    blocks: "ブロック",
    guide: "ステークガイド",
    onto: "ONTO",
    owallet: "OWallet",
    historyround: "Round",
    startheight: "Start Height",
    endheight: "End Height",
    starttime: "Start Time",
    endtime: "End Time",
    processing: "Processing",
  },
  onto: {
    url: "https://ontology-1.gitbook.io/ontology-node-staking-docs/guides/ontology-node-staking-on-onto",
    guideText: "Node Staking on ONTO",
    item1: "ステップ1：",
    item2: "ONTO",
    item3: "をダウンロードする",
    item4: "https://app.ont.io/socialmedia/pic/jaimage019.png",
    item5: "ステップ2： ",
    item6: "ONTOを開き、ホームページの",
    item7: "「財布資産」",
    item8: "で",
    item9: "「ONT」",
    item10: "を選択します。",
    item11: "https://app.ont.io/socialmedia/pic/jaimage021.png",
    item12: "ステップ3： ",
    item13: "左下隅の",
    item14: "「質入れ」",
    item15: "をクリックして、質入れページに入ります。",
    item16: "https://app.ont.io/socialmedia/pic/jaimage023.png",
    item17: "ステップ4：",
    item18: "",
    item19: "「質入れノードをおすすめする」",
    item20:
      "をクリックし、質入れしたいノードを選択し、質入れの数を入力します（1 ONTの整数倍でなければなりません）。",
    item21: "注：",
    item22: "1 ONTを質入れする場合は、「1」を入力し、情報を確認し、",
    item23: "「今すぐ質入れ」",
    item24: "をクリックして、パスワードを入力し、質入れを完了してください。",
    item25: "https://app.ont.io/socialmedia/pic/jaimage025.png",
    item26: "https://app.ont.io/socialmedia/pic/jaimage027.png",
    item27: "ステップ5：",
    item28: "オーソライズが完了すると、",
    item29: "「私の質入れ」",
    item30: "ページで関連情報を表示できます。",
    item31: "https://app.ont.io/socialmedia/pic/jaimage029.png",
    item32: "ONG出金を実行するには、左下隅の",
    item33: "[収益を受け取ります]",
    item34: "をクリックします。",
    item35: "",
    item36: "",
    item37: "https://app.ont.io/socialmedia/pic/jaimage031.png",
    item38: "質入れを取り消す方法は？",
    item39: "",
    item40: "[私の質入れ]",
    item41: "ページで",
    item42: "[質入れをキャンセル]",
    item43: "をクリックします。キャンセルする前に、右上隅の",
    item44: "[説明]",
    item45: "をクリックして指示を注意深くお読みください。キャンセルした後、",
    item46: "「引き出す」",
    item47: "をクリックしてONTを出金できます。",
    item48: "",
    item49: "",
    item50: "https://app.ont.io/socialmedia/pic/jaimage033.png",
    ontoappurl: "https://onto.app/",
  },
  owallet: {
    url: "https://ontology-1.gitbook.io/ontology-node-staking-docs/guides/ontology-node-staking-on-owallet",
    guideText: "Node Staking on OWallet",
    item1: "ステップ1：",
    item2: "OWallet",
    item3: "のダウンロード",
    item4: " (Windows/macOS/Linux)",
    item5: "https://app.ont.io/socialmedia/pic/enimage001.png",
    item6: "ステップ2：",
    item7: "OWalletを開き、",
    item8: "[Stake Authorization]",
    item8ja: "を選択します",
    item9: "https://app.ont.io/socialmedia/pic/enimage003.png",
    item10: "ステップ3：",
    item11:
      "ノードリストを表示し、ノードを選択した後、後方矢印をクリックし、ONTを選択して財布を保存し、ノードオーソライズページに入ります。",
    item12: "注：",
    item13: "右上の",
    item14: "[My Stake]",
    item15: "をクリックして、完了した質入れを表示します。",
    item16: "https://app.ont.io/socialmedia/pic/enimage005.png",
    item17: "ヒント：",
    item18:
      "投資収益率を比較することにより、より収益性が高いと思われるノードを選択できます。",
    item19: "OWalletは、Ledger財布の使用もサポートしています。",
    item20: "https://app.ont.io/socialmedia/pic/enimage007.png",
    item21: "ステップ4：",
    item22: "",
    item23: "「Submit new stake authorization」",
    item23ja: "をクリックします",
    item24:
      "質入れONT数を入力してください、1 ONTごとが最小質入れ単位です。パスワードを入力し、[OK]をクリックして質入れを完了します。",
    item25: "https://app.ont.io/socialmedia/pic/enimage009.png",
    item26: "https://app.ont.io/socialmedia/pic/enimage011.png",
    item27: "質入れを取り消す方法は？",
    item28: "",
    item29: "[Cancel stake authorization]",
    item30: "をクリックし、キャンセルする数量を入力します。",
    item31: "https://app.ont.io/socialmedia/pic/enimage013.png",
    item32: "https://app.ont.io/socialmedia/pic/enimage015.png",
    item33: "質入れ済みのONTおよびONG報酬を出金する方法は？",
    item34ja: "[Redeem]",
    item34: "をクリックして、ONTとバンドルされていないONGを出金します。",
    item35:
      "備考：出金可能なONTは、現在のノードで質入れされたONTの数です、バインドされていないONGおよびONG報酬は、質入れ期間中に取得されたONGの数です。",
    item36: "https://app.ont.io/socialmedia/pic/enimage017.png",
    owalleturl: "https://github.com/ontio/OWallet/releases",
  },
  calculator: {
    title: "Node & Staking Yield Calculator",
    node: "Node",
    user: "Staker",
    choosenodetype: "Please select the node type you want to operate",
    choosenodetypeuser: "Please select the node you want to stake into",
    typemsg:
      "For more details of the yield calculation methods for consensus node and candidate node, please refer to the",
    doc: "Ontology Staking Incentive Calculation whitepaper",
    url: "https://node.ont.io/Ontology%20Staking%20Incentive%20Calculation_202109.pdf",
    cnode: "Consensus node",
    nnode: "Candidate node",
    stakeamount: "Intended stake amount (ONT)",
    stakeamountuser: "Please select the node you want to stake into",
    amountMsg1: "Minimum stake required to become a consensus node: ",
    amountMsg2: "Minimum stake required to become a candidate node: ",
    amountMsg3: "Maximum stake required to become a candidate node: ",
    reward: "Node fee sharing ratio (% for node itself)",
    result: "Result",
    totalincome: "Total yield:",
    totalrate: "Expected yield rate:",
    totalong: "Expected total ONG yield:",
    detail: "Details",
    feerate: "Expected fee yield rate:",
    feeong: "Expected fee yield (ONG):",
    releaserate: "Expected released ONG yield rate:",
    releaseong: "Expected released ONG:",
    foundationrate: "Expected Ontology Foundation Bonus yield rate:",
    foundationong: "Expected Ontology Foundation Bonus (ONG):",
    choosenode: "Select a node",
    maxstakeMsg: "Maximum stake amount for this node: ",
    nodeChangeMsg:
      "Your stake will make the node a consensus node in the next round, and the yield will change. For specific calculation rules, please refer to",
    calc: "Calculate",
    disclaimtitle: "Disclaimer:",
    disclaimq: "How accurate is this calculation?",
    disclaima:
      "The effective yield depends on many dynamic variables, such as the ONT & ONG prices, total staked amount on the network, and total ONT staked on each node. The presented results are based on our own prediction formulas, and we do not guarantee any specific accuracy. The result is only a rough estimate and should not be used as financial advice.",
  },
  footer: {
    flag: "ja",
    Development: "開発",
    DeveloperCenter: "開発者センター",
    dApp: "dApp List",
    Tutorials: "教程",
    Documentation: "ドキュメントセンター",
    Bounty: "賞金プログラム",
    SmartX: "SmartX",
    Github: "Github",
    Cooperation: "合作",
    CooperateWithOntology: "与本体合作",
    TrustEcosystem: "信任生态",
    Nodes: "ノード",
    About: "について",
    Press: "新闻",
    TechNews: "本体视点",
    Team: "团队",
    AboutOntology: "Ontologyについて",
    WhitePaper: "ホワイトペーパー",
    Explorer: "エクスプローラー",
    dApps: "dApps",
    dAppsList: "dApp List",
    SubmitAdApp: "Submit a dApp",
    node: "ノード",

    aboutUs: "オントロジーについて",
    joinUs: "採用情報",
    Branding: "ブランディング",
    Partners: "パートナー",
    ContactUs: "お問い合せ",
    useOntology: "オントロジーを利用する",
    OntOng: "ONT & ONG",
    Bridge: "ブリッジ",
    NodesStaking: "ノード&資産抵当",
    OWallet: "OWallet",
    ONTO: "ONTOウォレット",
    Developers: "開発者",
    GetTestnetTokens: "テストネットトークンを入手",
    StakeOnt: "Stake ONT",
    stONT: "stONT",
    Docs: "Docs",
    Calculator: "Calculator",
    RunANode: "Run A Node",
    Discord: "Discord",
    CommunityForm: "Community Forum",
  },
};
